var path = './migrate-home-drive/content_partial.html';
var html = "<div class=\"full-height\" migration-iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;